module.exports = __webpack_public_path__ + "img/img-buildings.7b28c07.png";